import { message } from 'antd'
import mapValues from 'lodash/mapValues'
import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import api from '../../api'
import { PageHeader } from '../Common'
import { toPath } from '../../routes'
import DeviceModelForm from './Form'

export default function NewDeviceModel() {
  const navigate = useNavigate()
  const goToList = useCallback(
    () => navigate(toPath.deviceModels()),
    [navigate],
  )

  const onSubmit = useCallback(
    async ({ manufacturer, name, deviceTypeId, icmCapable }, { setErrors }) => {
      try {
        await api.deviceModels.create({
          manufacturer,
          name,
          deviceTypeId,
          icmCapable,
        })
        message.success('Device Model successfully created')
        goToList()
      } catch (e) {
        if (e.response && e.response.errors) {
          setErrors(mapValues(e.response.errors, fieldErrors => fieldErrors[0]))
        } else {
          message.error(e.message)
        }
      }
    },
    [goToList],
  )

  return (
    <div>
      <PageHeader title="New Device Model" onBack={() => navigate(-1)} />
      <DeviceModelForm onSubmit={onSubmit} />
    </div>
  )
}
